const PaymentSolutions = () => {
    return (
      <div>
          <div className="flex flex-col justify-center items-center">
          <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
             
              <div className="flex flex-col justify-center">
                <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                    Payment Solutions
                </h1>
                <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                TCS provides customers with a convenient way to pay bills, taxes, challans and fines on time. 
                The service extends to all local utility companies, mobile phone top-ups, most internet service 
                providers, several digital wallets, Sindh Revenue Board (SRB) and many other ‘branchless banking’ services. 
                It is a cash-only service. As a non-banking bill initiator, TCS is authorised to process all bills that are 
                part of 1Link portfolio. In combination with a full-service, in-plant digital printing facility, and managed 
                mailroom services, TCS Financial Services mechanisms are fully capable of implementing solutions for all kinds 
                of ticket-sales.
                </p>
                {/* <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                With a vast branch network, an in-plant, full-service digital printing facility, and managed mail services, 
                TCS can also provide ticket-sales service for all kind of events. TCS team and service mechanisms are fully 
                capable of designing and implementing customised solutions for all financial transaction and ticket-sales.
                </p> */}
              </div>
              <div className="flex-1 flex flex-col justify-center items-center">
                <img src="/DomesticScrollingBanner/image14.jpg" alt="" className="rounded-md max-w-[100%] sm:mt-[0rem] mt-[1rem]"/>
              </div>
            </div>
          
          </div>
        </div>
    
    )
};
export default PaymentSolutions;